/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 *
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 */

// Auto-generated by policy-check in @fluidframework/build-tools.

export const shortCodeMap = {
    "0x000": "nonzero isobuffer byte offset",
    "0x001": "unexpected isobuffer byte length",
    "0x003": "Primary to add to range < last primary!",
    "0x004": "Secondary to add to range < last secondary!",
    "0x005": "Target primary to retrieve < first range's primary!",
    "0x006": "Target primary to retrieve < last range's primary!",
    "0x007": "Target primary to update < first range's primary!",
    "0x008": "Target primary to update < last range's primary!",
    "0x009": "After update, target primary is not first range's primary!",
    "0x00a": "Running timer missing handler",
    "0x00b": "Handler executed without deferred",
    "0x00c": "messageId is incorrect from from the local client's ACK",
    "0x00d": "Missing message handler for message type",
    "0x00e": "Missing message handler for message type",
    "0x00f": "pendingMessageId is missing from the local client's operation",
    "0x010": "Received out of order storage op when there is an unackd clear message",
    "0x011": "pendingMessageId is missing from the local client's operation",
    "0x012": "pendingMessageId is missing from the local client's operation",
    "0x013": "Received out of order op when there is an unackd clear message",
    "0x014": "pendingMessageId is missing from the local client's operation",
    "0x015": "pendingMessageId is missing from the local client's clear operation",
    "0x016": "apply stashed op not implemented for custom value type ops",
    "0x017": "Trying to add invalid handle!",
    "0x018": "Trying to insert handle into position with already valid handle!",
    "0x019": "SharedMatrix.openUndo() supports at most a single IUndoConsumer.",
    "0x01a": "Trying to set out-of-bounds cell!",
    "0x01b": "Trying to set multiple out-of-bounds cells!",
    "0x01c": "The 'localSeq' of the vector submitting an op must >= the 'localSeq' of the other vector.",
    "0x01d": "Trying to submit message to runtime while detached!",
    "0x01e": "Row and col collab window 'localSeq' desynchronized!",
    "0x01f": "Row and col collab window 'collaborating' status desynchronized!",
    "0x020": "Unknown SharedMatrix 'op' type.",
    "0x021": "SharedMatrix message contents have unexpected type!",
    "0x022": "SharedMatrix row and/or col handles are invalid!",
    "0x023": "The 'localSeq' of pending write (if any) must be <= the localSeq of the currently processed op.",
    "0x024": "Start of PermutationSegment already allocated!",
    "0x025": "Trying to set start of PermutationSegment to invalid handle!",
    "0x026": "Trying to split segment at out-of-bounds position!",
    "0x027": "Trying to get handle of out-of-bounds position!",
    "0x028": "'localSeq' for op being resubmitted must be <= the 'localSeq' of the last submitted op.",
    "0x029": "Invalid handle at start of containing segment!",
    "0x02a": "On vector undo, unexpected 'currentOp' type/state!",
    "0x02b": "Must not nest calls to IRevertible.revert()",
    "0x02c": "On cellSet(), invalid row and/or column handles!",
    "0x02d": "Unexpected op type on range remove!",
    "0x02e": "Unexpected op type on range annotate!",
    "0x02f": "Unexpected op type on range insert!",
    "0x030": "Incoming remote op sequence# <= local collabWindow's currentSequence#",
    "0x031": "Incoming remote op minSequence# < local collabWindow's minSequence#",
    "0x032": "localSeq greater than collab window",
    "0x033": "Segment group undefined",
    "0x034": "Segment group not at head of merge tree pending queue",
    "0x035": "Segment group not at head of segment pending queue",
    "0x036": "Segment has no pending properties",
    "0x037": "Segment already has assigned sequence number",
    "0x038": "Incoming op sequence# < local collabWindow's currentSequence#",
    "0x039": "Incoming op sequence# < minSequence#",
    "0x03a": "Number of ops in 'resetOp' must match the number of segment groups provided.",
    "0x03b": "Number of ops in 'resetOp' must match the number of segment groups provided.",
    "0x03c": "Reset op has 'group' delta type!",
    "0x03d": "segmentGroup is array rather than singleton!",
    "0x03e": "minSeq mismatch between collab window and delta manager!",
    "0x03f": "New format should not emit catchup ops",
    "0x040": "Child count is not within [1,7] range!",
    "0x041": "Unexpected child ordinal length!",
    "0x043": "On ack, unexpected segmentGroup!",
    "0x044": "On annotate ack, missing segment property manager!",
    "0x045": "On insert, seq number already assigned!",
    "0x046": "On remove ack, missing removal info!",
    "0x048": "onMinGE()",
    "0x049": "Trying to reload from segments while collaborating!",
    "0x04f": "minSeq of collab window > target minSeq!",
    "0x050": "Next segment changes are undefined!",
    "0x051": "Too many children on merge block!",
    "0x054": "Sequence number less than minSeq!",
    "0x055": "Sequence number is not sorted!",
    "0x056": "Unexpected total for accumulation of all seglen adjustments!",
    "0x057": "Negative length after length adjustment!",
    "0x058": "Both overlapRemoveClients and clientPartials are set!",
    "0x059": "Client view exists but flat view does not!",
    "0x05a": "Mismatch between number of partial lengths on client and flat views!",
    "0x05b": "Flat view exists but client view does not!",
    "0x05c": "Trying to update more annotate props than do exist!",
    "0x05d": "emit: mismatch in segmentsTotalLength",
    "0x05e": "emit: mismatch in totalSegmentCount",
    "0x05f": "Missing blob header on legacy snapshot!",
    "0x060": "There should be only one blob with catch up ops",
    "0x061": "Mismatch in totalLength",
    "0x062": "Mismatch in totalSegmentCount",
    "0x063": "Mismatch in totalLength",
    "0x064": "Mismatch in totalSegmentCount",
    "0x065": "On removal info preservation, segment has invalid removed sequence number!",
    "0x066": "Corrupted preservation of segment metadata!",
    "0x067": "Missing clientId for removal!",
    "0x068": "On consensusOrderedCollection load, job tracking size > 0",
    "0x069": "On consensusOrderedCollection load, data size > 0",
    "0x06a": "Trying to submit message while detached!",
    "0x06b": "Loading snapshot into a non-empty collection",
    "0x06c": "Value should be undefined or non-empty",
    "0x06d": "SharedObjects contained in ConsensusRegisterCollection can no longer be deserialized as of 0.17",
    "0x06e": "Message's reference sequence number < op's reference sequence number!",
    "0x06f": "data missing for non-atomic inbound update!",
    "0x070": "sequence numbers are expected to be 0 when unattached",
    "0x071": "Versions should naturally be ordered by sequenceNumber",
    "0x072": "Unexpected local op when loading not finished",
    "0x073": "Sequence message not operation",
    "0x074": "Snapshot called when not fully loaded",
    "0x075": "SummarySerializer should be used for serializing data during summary.",
    "0x078": "Possible re-entrancy! Summary should not already be in progress.",
    "0x079": "Possible re-entrancy! Summary should have been in progress.",
    "0x07a": "Services should be there to attach delta handler",
    "0x07b": "Unexpected op",
    "0x07c": "Unexpected op type",
    "0x07d": "Unexpected op",
    "0x07e": "Unexpected op type",
    "0x07f": "clientId undefined",
    "0x080": "Invalid document service!",
    "0x081": "Document service already set!",
    "0x082": "Document storage service already set!",
    "0x083": "User selection status does not match replay controller use status!",
    "0x084": "On storage resolve, user selection already made!",
    "0x085": "On storage resolve, missing storage!",
    "0x086": "After storage resolve, user selection status still false!",
    "0x088": "Missing button ops button!",
    "0x089": "Stringified length of chunk contents > total starting length",
    "0x08a": "resetting ChunkedOpProcessor that never wrote back its contents",
    "0x08b": "Unexpected type on contents for fix of an attach!",
    "0x08c": "innerContent for fixing op contents is undefined!",
    "0x08d": "After sanitize, pending incomplete ops!",
    "0x08e": "Potentially missed initial messages",
    "0x08f": "No op handler is setup!",
    "0x090": "No signal handler is setup!",
    "0x091": "Retrieved ops' first sequence number has unexpected value!",
    "0x092": "version input for reading snapshot tree is null!",
    "0x093": "invalid version input for reading snapshot tree!",
    "0x094": "Missing snapshot tree!",
    "0x096": "Trying to remove valid tree IDs in removeNullTreeIds()!",
    "0x097": "Missing param from office.com URL parameter",
    "0x098": "OuterDocumentServiceFactoryProxy unavailable",
    "0x099": "OuterUrlResolverProxy unavailable",
    "0x09a": "'documentId' must be a defined, non-zero length string.",
    "0x09d": "Connection details should contain epoch",
    "0x09f": "No more socketIO refs to remove!",
    "0x0a0": "Unexpected socketIO references on timeout",
    "0x0a1": "Socket reference set unexpectedly does not point to this socket!",
    "0x0a2": "reentrancy not supported!",
    "0x0a4": "Unexpected blob encoding type",
    "0x0a5": "Trying to set ops when they are already set!",
    "0x0a8": "Docid should not contain slashes!!",
    "0x0ad": "Snapshot entry has both a tree value and a referenced id!",
    "0x0ae": "Tried to create rate limiter with 0 max requests!",
    "0x0b0": "Missing document snapshot tree!",
    "0x0b1": "Storage service not initialized",
    "0x0b2": "Missing orderer URL!",
    "0x0b7": "Pathname should be defined",
    "0x0b8": "'tenantId' and 'documentId' must be defined, non-zero length strings.",
    "0x0b9": "PathName should exist",
    "0x0ba": "Tenant id should exist",
    "0x0bb": "Document id should exist",
    "0x0bc": "Runtime has no DataObject!",
    "0x0bd": "Object runtime already has DataObject!",
    "0x0be": "Trying to initialize from existing while initProps is set!",
    "0x0bf": "set called recursively from the interception callback",
    "0x0c0": "set called recursively from the interception callback",
    "0x0c1": "Interception wrapper methods called recursively from the interception callback",
    "0x0c2": "Interception wrapper methods called recursively from the interception callback",
    "0x0c3": "Interception wrapper methods called recursively from the interception callback",
    "0x0c4": "Interception wrapper methods called recursively from the interception callback",
    "0x0c5": "Interception wrapper methods called recursively from the interception callback",
    "0x0c6": "Interception wrapper methods called recursively from the interception callback",
    "0x0c7": "Interception wrapper methods called recursively from the interception callback",
    "0x0c8": "Interception wrapper methods called recursively from the interception callback",
    "0x0c9": "Interception wrapper methods called recursively from the interception callback",
    "0x0ca": "Trying to use legacy graph attach!",
    "0x0cd": "Container disconnected while waiting for ops!",
    "0x0cf": "disconnect event was not raised!",
    "0x0d1": "Container should be attached before close",
    "0x0d2": "resolved url should be valid Fluid url",
    "0x0d3": "Should only be called in detached container",
    "0x0d6": "Inbound queue should be empty when attaching",
    "0x0d9": "Attempting to connect() a closed DeltaManager",
    "0x0dd": "Existing context not disposed",
    "0x0de": "Mismatch in connection state while setting",
    "0x0df": "Missing active connection",
    "0x0e0": "lost minBlobSize policy",
    "0x0e2": "DeltaManager already has attached op handler!",
    "0x0e3": "Newly set op handler is null/undefined!",
    "0x0e4": "Lost old connection!",
    "0x0e6": "old connection exists on new connection setup",
    "0x0e7": "claims/connectionMode mismatch",
    "0x0e8": "readonly perf with write connection",
    "0x0e9": "messageBuffer is not empty on new connection",
    "0x0eb": "Missing connection for reconnect",
    "0x0ec": "Unexpected value for previously processed message's sequence number",
    "0x0ed": "non-system message have to have clientId",
    "0x0ee": "Not accounting local messages correctly",
    "0x0ef": "client seq# not growing",
    "0x0f0": "Incoming local client seq# > generated by this client",
    "0x0f2": "previouslyProcessedMessage",
    "0x0f3": "not positive",
    "0x0f4": "Nonzero pause-count on resume()",
    "0x0f6": "real blob ID exists",
    "0x0f7": "aggregate blob missing",
    "0x0f8": "blob from aggregate blob exists on its own",
    "0x0f9": "never read summary",
    "0x0fa": "virtual blob not found",
    "0x0fb": "logic err with aggregator",
    "0x0fc": "tree reuse at lower level",
    "0x0fd": "data stores are writing incremental summaries!",
    "0x0fe": "attachment is aggregate blob",
    "0x0ff": "duplicate aggregate blob",
    "0x100": "logic error",
    "0x101": "Unexpected tree entry type on flatten!",
    "0x102": "invalid level of concurrency",
    "0x103": "trying to parallel run while not working",
    "0x104": "undefined end point for parallel fetch",
    "0x105": "unexpected end point for parallel fetch",
    "0x107": "ending dispatch with remaining results to be sent",
    "0x108": "ending results dispatch but knew in advance about more requests",
    "0x109": "unexpected next chunk position",
    "0x10a": "cannot add parallel request while not working",
    "0x10b": "invalid parallel request range",
    "0x10c": "invalid parallel request start point",
    "0x10d": "invalid parallel request end point",
    "0x10e": "should not throw result if we knew about boundary in advance",
    "0x10f": "empty/partial chunks should not be returned by caching",
    "0x110": "callback should retry until valid fetch before it learns new boundary",
    "0x112": "cannot push onto queue if done",
    "0x113": "deferred queue should be empty",
    "0x114": "cannot pop if deferred",
    "0x115": "queue should not be done during pop",
    "0x116": "Missing handle on scheduler load",
    "0x117": "Trying to get missing clientId!",
    "0x118": "Bad client interactive check",
    "0x119": "This agent became inactive while releasing",
    "0x11a": "Unsuccessful registration",
    "0x11b": "Trying to clear tasks on inactive agent",
    "0x11c": "Detached object routing context",
    "0x11d": "task is already running",
    "0x11e": "client is undefined",
    "0x11f": "requesting unknown blobs",
    "0x120": "Undefined latency statistics (op send time)",
    "0x121": "Undefined inner contents type!",
    "0x122": "Message to unpack is not proper runtime message",
    "0x124": "inconsistent readonly property/event state",
    "0x125": "Unsafe to transition to read-only state!",
    "0x126": "Expected createSubRequest url to include a leading slash",
    "0x127": "dirty document event not set on replay",
    "0x12a": "Missing blob id on metadata",
    "0x12b": "did not get root data store",
    "0x12d": "Container Context should already be in attaching state",
    "0x12e": "Container Context should already be in attached state",
    "0x12f": "Container Runtime's summarize should always return a tree",
    "0x131": "Mismatch between new chunkId and expected chunkMap",
    "0x132": "sending ops in detached container",
    "0x133": "Container disconnected when trying to submit system message",
    "0x137": "Failed to get version from storage",
    "0x138": "Failed to get snapshot from storage",
    "0x139": "Undefined package path",
    "0x13a": "Data store ID contains slash",
    "0x13b": "datastore context is already in bound state",
    "0x13c": "undefined channel on datastore context",
    "0x13d": "Detached runtime creation on realize()",
    "0x13e": "Unexpected package path",
    "0x13f": "datastore context registry is already set",
    "0x140": "undefined channel on datastore context",
    "0x141": "Unexpected connected state",
    "0x142": "local store channel is not loaded",
    "0x143": "Channel should not be undefined when running GC",
    "0x144": "Channel should be loaded when updating used routes",
    "0x145": "Channel should be present when data store is loaded",
    "0x146": "Channel must exist when submitting message",
    "0x147": "Channel must exist on submitting signal",
    "0x148": "Detached runtime creation on runtime bind",
    "0x149": "Undefined channel deferral",
    "0x14a": "Undefined package path",
    "0x14b": "Channel must exist when resubmitting ops",
    "0x14c": "Channel must exist when rebasing ops",
    "0x14d": "Should move from detached to attaching",
    "0x14e": "Should move from attaching to attached",
    "0x14f": "There should be a channel when generating attach message",
    "0x150": "pkg should be available in local data store context",
    "0x152": "pkg should be available in local data store",
    "0x154": "runtime creation is already attached",
    "0x155": "channel deferral is already set",
    "0x156": "Unexpected factory for package path",
    "0x157": "datastore registry already attached",
    "0x158": "Creating store with existing ID",
    "0x159": "The given id was not found in notBoundContexts to delete",
    "0x15a": "Cannot find context to resolve to",
    "0x15b": "Expected this id to already be removed from notBoundContexts",
    "0x15c": "Cannot find deferred to resolve",
    "0x15d": "Creating store with existing ID",
    "0x15e": "Local object does not have matching attach message id",
    "0x15f": "Could not find unbound context to bind",
    "0x160": "There should be a store context for the op",
    "0x161": "There should be a store context for the op",
    "0x162": "There should be a store context for the op",
    "0x163": "Missing datastore for local signal",
    "0x165": "Summarizer cannot work if client has local changes",
    "0x166": "BaseSnapshot should be there as detached container loaded from snapshot",
    "0x167": "Used route does not belong to any known data store",
    "0x168": "Expected tree in snapshot not found",
    "0x169": "No pending message found for this remote message",
    "0x16b": "The pending batch state indicates we are already processing a batch",
    "0x16d": "There is no pending batch begin message",
    "0x16e": "Batch with single message should not have batch metadata",
    "0x16f": "Did not receive batch begin metadata",
    "0x170": "Did not receive batch end metadata",
    "0x171": "No pending state found for the remote message",
    "0x172": "The connection state is not consistent with the runtime",
    "0x173": "replayPendingStates called twice for same clientId!",
    "0x174": "initial states should be empty before replaying pending",
    "0x175": "Can only broadcast if summarizer starts in local state",
    "0x176": "Can only ack/nack if summarizer is in broadcasting state",
    "0x177": "Missing delta handler",
    "0x178": "Missing delta handler on attach",
    "0x179": "createChannel() with existing ID",
    "0x17a": "Channel should be loaded when created!!",
    "0x17b": "Channel to be binded should be in not bounded set",
    "0x17c": "Unexpected attach (local) channel OP",
    "0x17e": "Used route does not belong to any known context",
    "0x17f": "Not expecting detached channels during summarize",
    "0x180": "getAttachSummary should always return a tree",
    "0x181": "BaseSnapshot should be there as detached container loaded from snapshot",
    "0x182": "Data store should be attached to attach the channel.",
    "0x183": "There should be a channel context for the op",
    "0x184": "There should be a channel context for the op",
    "0x185": "Channel not found",
    "0x189": "Should always be remote because a local dds shouldn't generate ops before loading",
    "0x18a": "Channel should be loaded to resubmit ops",
    "0x18c": "Channel should be loaded to summarize",
    "0x18d": "Channel should be loaded to take snapshot",
    "0x18e": "Channel must not already be loaded when loading",
    "0x190": ".attributes blob should be present",
    "0x192": "Channel should be there if loaded!!",
    "0x193": "Channel should be loaded to run GC",
    "0x194": "Remote channel must be loaded when rebasing op",
    "0x195": "Remote channel must not be local when processing op",
    "0x196": "Remote channel must be loaded when resubmitting op",
    "0x197": "Remote channel must not already be loaded when loading",
    "0x198": "Used route should always be an absolute route",
    "0x19a": "Invalid response value for Fluid object request",
    "0x19b": "Cannot not create response error on 200 status",
    "0x19c": "storage service path has trailing separator",
    "0x19d": "Handles should always have absolute paths",
    "0x19f": "wipSummaryLogger should not be set yet in startSummary",
    "0x1a0": "Already tracking a summary",
    "0x1a1": "summarize should not be called when not tracking the summary",
    "0x1a2": "wipSummaryLogger should have been set in startSummary or ctor",
    "0x1a3": "wipSummaryLogger should have been set in startSummary or ctor",
    "0x1a4": "Not tracking a summary",
    "0x1a5": "Tracked summary local paths not set",
    "0x1a6": "Not found pending summary, but this node has previously completed a summary",
    "0x1a7": "Pending summary reference sequence number should be consistent",
    "0x1a9": "When loading base summary, expected outstanding ops <= tracking sequence number",
    "0x1aa": "Out of order change recorded",
    "0x1ab": "Create SummarizerNode child already exists",
    "0x1ac": "Cannot create child from summary if parent does not have latest summary",
    "0x1ad": "Missing child summary tree",
    "0x1ae": "Child summary object is not a tree",
    "0x1af": "Outstanding ops blob missing, but base summary tree exists",
    "0x1b0": "Base summary tree missing, but outstanding ops blob exists",
    "0x1b1": "wip used routes should be set if tracking a summary",
    "0x1b2": "Getting GC data should not be called when GC is disabled!",
    "0x1b3": "GC data cannot be retrieved without getGCDataFn",
    "0x1b4": "We should not already be tracking used routes when to track a new summary",
    "0x1b5": "We should have been tracking used routes",
    "0x1b6": "Create SummarizerNode child already exists",
    "0x1b7": "Bad session state for processing quorum messages",
    "0x1b8": "Bad session state for processing quorum messages",
    "0x1b9": "Unexpected value for sequence number of first message in file",
    "0x1ba": "should not return empty buckets",
    "0x1bb": "Unexpected sequence number on first of messages to save",
    "0x1bc": "Unexpected sequence number on last of messages to save",
    "0x1bd": "Stopped writing at unexpected sequence number",
    "0x1c5": "snapshot should be set before retrieving it",
    "0x1c6": "snapshot should be set before retrieving it",
    "0x1c7": "snapshot should be set before retrieving it as expanded string",
    "0x1c8": "Mismatch between document sequence number and current op number",
    "0x1c9": "Leftover documents after replay!",
    "0x1ca": "replay-to target is <= current op in replay cycle",
    "0x1cb": "Bad window to verify snapshot",
    "0x1cc": "Unexpected previous snapshot op number",
    "0x1ce": "clientId not found",
    "0x1cf": "clientId not found",
    "0x1d0": "sequenceNumber not found",
    "0x1d3": "Missing client id on disconnect",
    "0x1d5": "Invalid snapshot format version",
    "0x1d6": "Parent summary object is not a tree",
    "0x1d8": "Should only transition from Connecting state",
    "0x1d9": "addRequestCore() should break into smaller chunks",
    "0x1da": "Client id should be set if connected",
    "0x1db": "epoch exists",
    "0x1dc": "all entries have to have epoch",
    "0x1dd": "no epoch",
    "0x1de": "Not an ODSP resolved url",
    "0x1e0": "Protocol and App summary trees should be present",
    "0x1e2": "Caller must ensure 'isAttached()' before calling 'sendSetCellOp'.",
    "0x1e4": "Unexpected serializable type",
    "0x1e5": "Storage token should not be null",
    "0x1e6": "Epoch  should be present in response",
    "0x1e7": "caching was not performed!",
    "0x1e8": "reentrancy",
    "0x1e9": "Pending ops",
    "0x1ea": "Prefetch snapshot only available for odsp!",
    "0x1eb": "Snapshot should be prefetched!",
    "0x1ec": "No refresh token provided.",
    "0x1ed": "Share link should be present",
    "0x1ef": "services must be defined",
    "0x1f0": "Unexpected mismatch in readonly",
    "0x1f5": "Attached state should have storage",
    "0x1f6": "Negative client sequence number not allowed",
    "0x1f7": "Previous client should always be defined",
    "0x1f8": "local BlobAttach op with no pending blob",
    "0x1fc": "summary is not a tree",
    "0x1fe": "isolated channels subtree should exist in remote datastore snapshot",
    "0x1ff": "isolated channels subtree should exist in local datastore snapshot",
    "0x200": "Returned odsp snapshot is malformed. No trees!",
    "0x201": "Returned odsp snapshot is malformed. No blobs!",
    "0x203": "Summary handle is undefined",
    "0x205": "attach() called more than once",
    "0x207": "Channel should be defined",
    "0x208": "Factory should be undefined before loading",
    "0x209": "Factory Type should be defined",
    "0x20a": "register for event on disposed object",
    "0x20b": "mismatch",
    "0x20c": "connection disposed",
    "0x20d": "double connection listener",
    "0x20e": "double tracked listener",
    "0x20f": "Driver min read version should >= to server minReadVersion",
    "0x210": "Snapshot should be created with minReadVersion or above",
    "0x219": "1 root should be there",
    "0x21b": "Snapshot id should be provided",
    "0x21c": "Seq number should be provided",
    "0x21d": "body is not string",
    "0x21e": "improper boundary format",
    "0x220": "socket key collision",
    "0x221": "Root tree should contain the id",
    "0x222": "Root tree should contain the id!!",
    "0x223": "unexpected end of buffer",
    "0x224": "Skip length should be positive",
    "0x225": "Data should be there",
    "0x226": "Should write complete data",
    "0x227": "Data should be there",
    "0x22b": "Should be a pair",
    "0x22c": "reading pairs",
    "0x231": "Number should be an integer",
    "0x232": "Payload should not be negative",
    "0x233": "Unexpected data at the end of buffer",
    "0x234": "has joinOpTimer",
    "0x235": "no joinOpTimer",
    "0x236": "In all cases it should be already installed",
    "0x237": "Snapshot should exist",
    "0x238": "called only in connected state",
    "0x239": "called only in disconnected state",
    "0x23a": "seq#'s",
    "0x23b": "we are not packing at the right level",
    "0x23c": "we are not packing at the right level",
    "0x23d": "pending is undefined",
    "0x23e": "pending is undefined",
    "0x23f": "pending undefined",
    "0x240": "Binary format snapshot only for odsp driver!!",
    "0x241": "disconnect should result in stopSequenceNumberUpdate() call",
    "0x242": "has timer",
    "0x243": "stopSequenceNumberUpdate should be called as result of sending any op!",
    "0x244": "Socket is closed, but connection is not!",
    "0x245": "tracked listener",
    "0x246": "checking consistency of socket & _disposed flags",
    "0x247": "Use addTrackedListener instead",
    "0x248": "should not subscribe to forwarded events",
    "0x24c": "Cannot call `flush()` from `orderSequentially`'s callback",
    "0x24e": "assertion for type narrowing",
    "0x250": "serialized container with attachment blobs must be rehydrated with detached blob storage",
    "0x251": "creation summary has to have seq=0 && handle === undefined",
    "0x252": "redirect table can only be set in detached container",
    "0x253": "redirect table already exists",
    "0x254": "unrecognized id in redirect table",
    "0x255": "detached blob id absent in redirect table",
    "0x256": "storage undefined in attached container",
    "0x257": "This is not summarizing container",
    "0x258": "connected",
    "0x259": "Container disconnected when trying to submit system message",
    "0x25b": "Caller is responsible for checking lock",
    "0x25d": "We should never connect as 'read'",
    "0x25e": "no reason to call fail if all promises have been completed",
    "0x25f": "retryAfterSeconds",
    "0x260": "Disposed should mean disconnected!",
    "0x261": "Expected: off",
    "0x262": "Old summarizer is still working!",
    "0x263": "Expected: starting",
    "0x264": "Expected: Not Off",
    "0x266": "lastKnownSeqNumber should never be below last processed sequence number",
    "0x267": "lastObservedSeqNumber should be updated first",
    "0x268": "There can't be pending fetch that early in boot sequence!",
    "0x269": "pending ops are not dropped",
    "0x26a": "not closed",
    "0x26b": "initial state",
    "0x26c": "handler should be installed",
    "0x26d": "wrong start",
    "0x26e": "wrong start",
    "0x26f": "continuous and no duplicates",
    "0x270": "All requested ops fetched",
    "0x272": "empty request",
    "0x273": "Invalid document id from parsed URL",
    "0x274": "type check",
    "0x275": "Root tree should contain the id",
    "0x278": "API is not supported for non-connecting or closed container",
    "0x27b": "reentrancy may result in incorrect behavior",
    "0x280": "Validate first op seq number",
    "0x281": "Unreferenced if present should be true",
    "0x282": "Headers should be present now",
    "0x283": "Length of data len should fit in the bytes from the map",
    "0x284": "Length of id should fit in the bytes from the map",
    "0x285": "Start code should not undefined",
    "0x286": "End code should not undefined",
    "0x287": "key must exist in the map",
    "0x288": "All properties should exist",
    "0x289": "logic error",
    "0x28a": "can't be disposed - Callers need to ensure that!",
    "0x292": "Unexpected undefined result from getFileLinkCore",
    "0x293": "initial state",
    "0x294": "can't have op processing paused if we are processing an op",
    "0x295": "there should be no pending batch if we have no ops",
    "0x296": "we should never start processing incomplete batch!",
    "0x297": "always called from resumed state",
    "0x298": "we have something in the queue that generates this event",
    "0x299": "non-synchronized state",
    "0x29a": "System message in the middle of batch!",
    "0x29b": "system op in a batch?",
    "0x29c": "we should be processing ops when there is no active batch",
    "0x29d": "we should be processing ops when there is no active batch",
    "0x29e": "there can't be active batch",
    "0x29f": "we should be processing ops when there is no active batch",
    "0x2a0": "batch presence was validated above",
    "0x2a1": "logic error",
    "0x2a2": "Batch is interrupted by other client op. Should be caught by trackPending()",
    "0x2a3": "container should be closed on any error",
    "0x2a5": "join timer",
    "0x2a6": "waitingForLeaveOp should imply writeConnection (we need to be ready to flush pending ops)",
    "0x2a7": "Container is not attached",
    "0x2a8": "Expected data store snapshot tree in base snapshot",
    "0x2a9": "GC nodes for data store not in GC blob",
    "0x2ac": "Connected when timeout waiting for leave from previous session fired!",
    "0x2ad": "GC blob missing from snapshot",
    "0x2ae": "node id should always be an absolute route",
    "0x2af": "Child GC data should have been initialized",
    "0x2b0": "Used route should always be an absolute route",
    "0x2b1": "This should have be initiallized when generate GC nodes above",
    "0x2b2": "Two entries for the same GC node with different unreferenced timestamp",
    "0x2b3": "logic error",
    "0x2b4": "not connected on sending ops!",
    "0x2b5": "logic error",
    "0x2b6": "Missing data store context",
    "0x2b8": "Chunk should be set in map",
    "0x2ba": "batchBegin must fire before batchEnd",
    "0x2bb": "Instrumented token fetcher with throwOnNullToken = true should never return null",
    "0x2bc": "Instrumented token fetcher with throwOnNullToken =true should never return null",
    "0x2bd": "We should not see a pending FlushMode until we see a flush when processing a batch",
    "0x2be": "LocalReferences array contains a gap",
    "0x2bf": "both removedClientIds and removedSeq should be set or not set",
    "0x2c0": "ID must be created before adding interval to collection",
    "0x2c1": "Creating an interval collection that already exists?",
    "0x2c2": "Create Version should be equal to currentReadVersion",
    "0x2c4": "client should not be summarizer before container is created",
    "0x2c5": "Attempting to connect() a closed Container",
    "0x2c6": "Attempting to connect() a container that is not attached",
    "0x2c7": "Attempting to disconnect() a closed Container",
    "0x2c8": "outboundPushEventTime should be undefined",
    "0x2c9": "durationNetwork should be undefined",
    "0x2ca": "durationOutboundBatching should be undefined",
    "0x2cb": "submitOpEventTime should be undefined",
    "0x2cc": "OpTimeSittingInboundQueue should be undefined",
    "0x2cd": "durationNetwork should be undefined",
    "0x2ce": "msnTrackingTimestamp should not be undefined",
    "0x2cf": "undefined channel on datastore context",
    "0x2d0": "Data store should be globally visible to attach channels.",
    "0x2d1": "Data store should be locally visible before it can become globally visible.",
    "0x2d2": "Data store should be globally visible when its attached.",
    "0x2d3": "Local channel must be globally visible when processing op",
    "0x2d4": "Local channel must be globally visible when resubmitting op",
    "0x2d5": "Invalid blob node id in unused routes.",
    "0x2d7": "No data store with specified id",
    "0x2d8": "Empty change event should not be emitted.",
    "0x2da": "Unknown SharedMatrix 'op' type.",
    "0x2db": "Applying op must generate a pending segment",
    "0x2dc": "Cannot find code proposal",
    "0x2dd": "Cannot find blob for a given id",
    "0x2de": "Package path requested for unsupported node type.",
    "0x2df": "transient references cannot be bound to segments",
    "0x2e0": "lref not a Local Reference",
    "0x2e1": "Support for plain value types removed.",
    "0x2e2": "Must only wait for leave message when clientId in quorum",
    "0x2e3": "Must have a valid protocol handler instance",
    "0x2e4": "there should be service config for active connection",
    "0x2e5": "Must have a base snapshot",
    "0x2e6": "Must have a base snapshot",
    "0x2e7": "Must serialize base snapshot blobs before getting runtime state",
    "0x2e8": "There should be a store context for the op",
    "0x2e9": "Must call getLocalState() after applying initial states",
    "0x2ea": "Configuration state should be enabled",
    "0x2eb": "Summary not supported with configuration disabled",
    "0x2ec": "Blob must be present in blobsContents",
    "0x2ed": "There should be a channel context for the op",
    "0x2ee": "Channel should be loaded to rollback ops",
    "0x2ef": "Local channel must be globally visible when rolling back op",
    "0x2f0": "Remote channel must be loaded when rolling back op",
    "0x2f1": "slideReferences from a segment which has not been removed and acked",
    "0x2f2": "Ref not in the segment localRefs",
    "0x2f3": "Ref not in the segment localRefs",
    "0x2f4": "localRefs must be allocated",
    "0x2f5": "op create references must be SlideOnRemove",
    "0x2f6": "SlideOnRemove references must be op created",
    "0x2f8": "Unexpected accept op, nothing pending",
    "0x2f9": "Unexpected accept op, client not in expectedSignoffs",
    "0x2fa": "Unexpected pending message received",
    "0x2fb": "pendingMessageId does not match",
    "0x2fc": "Invalid localOpMetadata for clear",
    "0x2fd": "pendingMessageId does not match",
    "0x2fe": "Invalid localOpMetadata in submit",
    "0x2ff": "Unexpected pending message received",
    "0x300": "localSeq greater than collab window",
    "0x301": "Either seq or localSeq should be defined",
    "0x302": "No segment found",
    "0x303": "Invalid offset",
    "0x304": "Id cannot contain slashes",
    "0x305": "registerDependent on disposed Dependee",
    "0x306": "invalidateDependents on disposed Dependee",
    "0x307": "endInitialization should be called exactly once",
    "0x308": "onDispose should be set when disposing",
    "0x309": "Cannot unregister dependees on a disposed SimpleObservingDependent.",
    "0x30a": "shouldClientJoinWrite should imply this is a writeConnection",
    "0x30b": "Must have a valid protocol handler instance",
    "0x30c": "Id cannot contain slashes",
    "0x30d": "Id cannot contain slashes",
    "0x30e": "Id cannot contain slashes. DataStoreContext should have validated this.",
    "0x30f": "Channel context ID cannot contain slashes",
    "0x310": "Channel context ID cannot contain slashes",
    "0x311": "expected id to exist on interval",
    "0x312": "snapshot should be parsed",
    "0x313": "Specified user was not of type \"TinyliciousUser\".",
    "0x314": "Container properly closed",
    "0x315": "re-entrancy",
    "0x316": "There should be a cached promise of in-progress aliasing",
    "0x317": "dataStoreFactory is undefined",
    "0x318": "resolvedUrl is undefined",
    "0x319": "No delta connection server associated with specified document ID",
    "0x31a": "resolvedUrl is undefined",
    "0x31b": "container1.resolvedUrl is undefined",
    "0x31c": "rightDiv is undefined",
    "0x31d": "options are not of type \"IRouterliciousRouteOptions\" as expected",
    "0x31e": "options.tenantId is undefined",
    "0x320": "options.tenantId is undefined",
    "0x322": "options.fluidHost is undefined",
    "0x324": "options.server is undefined",
    "0x325": "options.odspAccessToken is undefined",
    "0x326": "lockResolver is undefined",
    "0x327": "options.server is undefined",
    "0x328": "options.server is undefined",
    "0x329": "browser.umd property is undefined",
    "0x32a": "pendingMessageId does not match",
    "0x32b": "Invalid localOpMetadata for clear",
    "0x32c": "pendingMessageId does not match",
    "0x32d": "Invalid localOpMetadata in submit",
    "0x32e": "Unexpected pending message received",
    "0x32f": "Invalid localOpMetadata for sub directory op",
    "0x330": "Unexpected pending message received",
    "0x331": "Unexpected pending message received",
    "0x332": "Unexpected pending message received",
    "0x333": "PathShared.splice can only insert detached ranges",
    "0x334": "Anchor must not be double freed",
    "0x335": "ObjectForest.getRoot only valid for existing roots",
    "0x336": "ObjectForest must only be given its own Anchors",
    "0x337": "ObjectForest must only be given its own Cursor type",
    "0x338": "ObjectForest must only be given its own Cursor",
    "0x339": "Anchor must not be double freed",
    "0x33a": "Anchor must not be double freed",
    "0x33b": "Cursor must not be freed",
    "0x33c": "Cursor must not be freed",
    "0x33d": "Cursor must be current to be used",
    "0x33e": "Cursor must be current to be used",
    "0x33f": "Cursor must not be double freed",
    "0x340": "Cursor must be current to be used",
    "0x341": "Cursor must be current to be used",
    "0x342": "Invalid usage. \"blobid\" should always be null",
    "0x343": "Invalid usage. \"count\" should always be 1",
    "0x344": "this.pendingConnection should be undefined",
    "0x345": "this.pendingConnection is undefined when trying to cancel",
    "0x346": "inboundQueuePausedFromInit should be true"
};
